import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";

export const cardBodyCSS = css({
  paddingBottom: vars.spacing[6],

  '[data-clay-card-inline="true"] &': {
    flex: 1,
  },
});
